<div class="contactus-details-right logfrm">
    <div class="log-logo">
        <img src="" alt="">
    </div>
    <div class="log-form patient-login">
        <div class="width-controller">
            <div class="text-center">
                <img src="assets/img/logo1.png" alt="NuvertOS Logo">
            </div>
            <h3 class="login-title" style="margin-bottom: 1.5rem;">Patient Portal</h3>
            <div *ngIf="!preRegister" class="log-ff">
                <div class="form-group">
                    <label class="login-label" for="input-mobile">Please verify your mobile number</label>
    
                    <div class="input-group">
                        <span class="input-group-text login-addons" id="email-addon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-open" viewBox="0 0 16 16">
                            <path d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.818l5.724 3.465L8 8.917l1.276.766L15 6.218V5.4a1 1 0 0 0-.53-.882l-6-3.2zM15 7.388l-4.754 2.877L15 13.117v-5.73zm-.035 6.874L8 10.083l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738zM1 13.117l4.754-2.852L1 7.387v5.73zM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2z"/>
                            </svg>
                        </span>
                        <input type="text" name="verify_number" class="form-control" required
                        [(ngModel)]="patient.mobile" pattern="^[6-9]\d{9}$"
                        placeholder="mobile" #otpNumber="ngModel" />
    
                    </div>
                    <div class="form-text error" *ngIf="otpNumber.touched && otpNumber.errors?.required">
                        Contact number is required!
                    </div>
                    <div class="form-text error" *ngIf="otpNumber.errors?.pattern">
                        Please enter 10 digit mobile number
                    </div>
                    <div class="form-text error" *ngIf="verifyAgain">
                        Timer has expired
                    </div>
                </div>
    
                <div class="form-group">
                    <button class="btn button brand-button login-but" disabled="" type="button" (click)="startTimer()" [disabled]="isExpired">
                        <i *ngIf="false" class="fas fa-spinner animate-spinner"></i> 
                        <span *ngIf="!otpSent">Verify</span>
                        <span *ngIf="otpSent && !verifyAgain">{{timeLeft}} sec</span>
                        <span *ngIf="verifyAgain">Resend</span>
                    </button>
                </div>
    
                <div class="form-group" *ngIf="otpSent">
                    <label class="login-label" for="input-mobile">Please enter the OTP</label>
    
                    <div class="input-group">
                        <span class="input-group-text login-addons" id="email-addon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-envelope-open" viewBox="0 0 16 16">
                            <path d="M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.818l5.724 3.465L8 8.917l1.276.766L15 6.218V5.4a1 1 0 0 0-.53-.882l-6-3.2zM15 7.388l-4.754 2.877L15 13.117v-5.73zm-.035 6.874L8 10.083l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738zM1 13.117l4.754-2.852L1 7.387v5.73zM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765l6-3.2z"/>
                            </svg>
                        </span>
                        <input type="text" class="form-control" [(ngModel)]="otp" name="otp">
                    </div>
                </div>
    
                <div class="form-group" *ngIf="otpSent">
                    <button class="btn button brand-button login-but" [disabled]="otp && otp.length < 6" type="button" (click)="verified()" [disabled]="isExpired">
                        Submit
                    </button>
                </div>
            </div>
            <div *ngIf="preRegister" class="log-ff">
                <div class="row">
                    <div class="col-md-3">
                        <label for="salutation" class="bx--label">Salutation</label>
                        <ng-select class="salutation-ddl" class="form-control" [items]="salutations" [(ngModel)]="preRegisterPatient.salutation" (change)="setGender()" id="salutation">
                        </ng-select>
                    </div>
                    <div class="col-md-9">
                        <label for="patientname" class="bx--label">Name</label>
                        <input id="patientname" type="text" class="form-control" [ngModel]="preRegisterPatient.patientname" placeholder="patient name" (ngModelChange)="patientNameSet($event)"/>
                    </div>
                </div>
                <div class="set-margin row">
                    <div class="col-md-3">
                        <label for="gender" class="bx--label">Gender</label>
                        <ng-select class="form-control" [items]="genders" id="gender" [(ngModel)]="preRegisterPatient.gender">
                        </ng-select>
                    </div>
                    <div class="col-md-9">
                        <label for="mobile" class="bx--label">Mobile</label>
                        <input  id="patientMobile" type="text" class="form-control" [(ngModel)]="preRegisterPatient.mobile" id="mobile" placeholder="mobile" />
                    </div>
                </div>

                <div class="row set-margin">
                    <div class="col-md-12">
                        <label for="mobile" class="bx--label">Address</label>
                        <input  id="address" type="text" class="form-control" [(ngModel)]="preRegisterPatient.address" id="address" placeholder="address" />
                    </div>
                </div>
                <div class="form-group">
                    <button class="set-margin btn button brand-button login-but" type="button" (click)="savePreRegisteration()" [disabled]="disableSubmit()">
                        Submit
                    </button>
                </div>
            </div>
            <div *ngIf="!preRegister" class="log-ff">
                <p class="patient-link" (click)="setPreRegisterPatient()">Pre-Register Patient</p>
            </div>
            <div *ngIf="preRegister" class="log-ff">
                <p class="patient-link" (click)="setPreRegisterPatient()">Patient Sign In</p>
            </div>

        </div>
    </div>
</div>